import { Controller } from '@hotwired/stimulus'

// Updates the parent form's action URL by substituting :id with the
// selected value from a child input/select.
//
// Usage:
//   <form data-controller="dynamic-action"
//         data-dynamic-action-template-value="/dashboards/:id/items">
//     <select data-action="change->dynamic-action#update">
export default class extends Controller {
  static values = { template: String }

  update(event) {
    const value = event.target.value
    if (!value) return

    this.element.action = this.templateValue.replace(':id', value)
  }
}
